import { IPlayer, ISiteSetting } from "../../../../../types/api";

const isPlayoffEligible = (
    player: IPlayer,
    currentYear: number,
    playoffEligibileDate?: ISiteSetting["setting"],
) => {
    const waiverDate =
        player.waiverAccepted &&
        player.waiverYear === currentYear &&
        new Date(player.waiverAccepted);

    if (!waiverDate) {
        return false;
    }

    const playoffDate = new Date(playoffEligibileDate as string);

    if (Number.isNaN(playoffDate.getTime())) {
        return false;
    }

    const waiverDay = Date.UTC(
        waiverDate.getFullYear(),
        waiverDate.getMonth(),
        waiverDate.getDate(),
    );
    const cutoffDay = Date.UTC(
        playoffDate.getUTCFullYear(),
        playoffDate.getUTCMonth(),
        playoffDate.getUTCDate(),
    );

    return waiverDay <= cutoffDay;
};

export default isPlayoffEligible;
